import { render, staticRenderFns } from "./LessonplanWork.vue?vue&type=template&id=28f7d472&"
import script from "./LessonplanWork.vue?vue&type=script&lang=js&"
export * from "./LessonplanWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports